import React from "react";
import { useKitchenNow } from "../../../../KDS/components/TimedOrderCard";
import { getKotItemKitchenTiming } from "./kotKitchenTiming";

const KotItemKitchenProgress = ({ item, matches = [], loadStatus = "ready" }) => {
  const now = useKitchenNow();
  const timing = getKotItemKitchenTiming(item, matches, now, loadStatus);
  const hasProgress = Number.isFinite(timing.progressPercent);
  const progress = hasProgress ? Math.min(100, Math.max(0, timing.progressPercent)) : null;
  const readiness = timing.statusKey === "ready";
  const isCancelled = item?.productStatus === "CANCELLED";

  return (
    <section
      className={`akm-kitchen-progress tone-${timing.tone} state-${timing.statusKey}`}
      aria-label={`Kitchen tracking for ${item?.productName || "item"}`}
      title={timing.description}
    >
      <div className="akm-kitchen-progress-top">
        <div className={`akm-kitchen-state ${isCancelled ? "cancelled" : ""}`}>
          <span className="akm-kitchen-state-dot" aria-hidden="true" />
          <span className="akm-kitchen-state-label" role="status">
            {isCancelled ? "Canceled by Kitchen"
              : item?.productStatus === "SERVED" ? "Served" : timing.statusLabel}
          </span>
        </div>
      </div>

      <div className="akm-kitchen-facts">
        <span
          className="akm-kitchen-prep-fact"
          title={timing.prepSource === "KOT average" ? "Prep estimate uses the KOT average, not an item-specific estimate." : undefined}
        >
          <b>Prep time</b>{timing.prepText}
          {timing.prepSource === "KOT average" && <small className="akm-kitchen-prep-source">KOT average</small>}
        </span>
        {timing.timeText && (
          <span className="akm-kitchen-time-text"
            role={timing.countdownDisplay ? "timer" : undefined}
            aria-label={timing.countdownDisplay ? "Preparation countdown" : undefined}>
            {timing.countdownDisplay
              ? <><span>{timing.countdownLabel}</span><strong>{timing.countdownDisplay}</strong></>
              : timing.timeText}
          </span>
        )}
      </div>

      {hasProgress && (
        <div className="akm-kitchen-progress-bottom">
          <div
            className="akm-kitchen-meter"
            role="progressbar"
            aria-label={readiness ? "Kitchen readiness" : "Elapsed prep window"}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={readiness ? 100 : Math.round(progress)}
            aria-valuetext={readiness ? "100% confirmed ready by kitchen" : timing.progressLabel}
          >
            <span className="akm-kitchen-meter-fill" style={{ width: `${readiness ? 100 : progress}%` }} />
          </div>
          <span className="akm-kitchen-progress-label">
            {readiness ? "Kitchen readiness · 100% confirmed" : timing.progressLabel}
          </span>
        </div>
      )}
    </section>
  );
};

export default KotItemKitchenProgress;
